import * as React from "react";
import { Button, Card, Elevation, Overlay,Classes,Intent,H3,Toaster,Position,Icon } from "@blueprintjs/core";

let Logo ="login.png";
var QRCode = require('qrcode.react');

export default class PanelLogout extends React.Component <{}> {
  
  constructor(props) {
    super(props);
    this.state = {
        ...props,
        isOpenL: false,
        isOpendcnx:false,
        isOpeninvit:false,
        uniqueid:'',
        nickname:'',
        data:this.props.data,
        codematiere:'',
        isscreensity:'none'
      };
    this.handleLogout = this.handleLogout.bind(this);
    
  }
  
  componentDidMount () {
    console.log("panellogout")
    console.log(this.state.pageid);
    console.log(this.props.data);
    
  }
  componentDidUpdate(prevProps: Readonly<{}>, prevState: Readonly<{}>, snapshot?: any): void {
    if(this.state.pageid!=this.props.pageid) 
    {
      this.setState({pageid:this.props.pageid});
      this.setState({data:this.props.data});
      if(this.props.data.length>0)if(this.props.data[0]!=undefined){this.setState({codematiere:this.props.data[0].code})}
    }
  
  }

  handleLogout() {
    this.props.handleLogout(true);
    this.setState({isOpenL:false});
  }
handleChangeNom=function(ev)
{
  console.log(ev.target.value);
  this.setState({nickname:ev.target.value});
}
  //Pour Signup
handleSendCnx=function()
{
  var that=this;  
  var xhr = new XMLHttpRequest();
        xhr.overrideMimeType("application/json");
        var formData = new FormData();
        formData.append('nickname', this.state.nickname .toLowerCase());
        formData.append('email', this.state.nickname.toLowerCase());
        formData.append('password', this.state.nickname);
        formData.append('code', this.state.codematiere);
        
        xhr.open('POST','/api/public/signupinvite')
        xhr.setRequestHeader("Content-Type", "application/json");

        //send the form data
        xhr.send(JSON.stringify(Object.fromEntries(formData)));

        xhr.onreadystatechange = function() {
            if (xhr.readyState == XMLHttpRequest.DONE) {
              console.log(xhr.responseText);
            var toaster=Toaster.create({className: "my-toaster", position: Position.TOP_RIGHT,});
             if(xhr.status==200) {
              var url=window.location.href
              url=url+"?id=" +xhr.responseText
              that.setState({uniqueid:url}); toaster.show( {icon:"new-person", intent:Intent.SUCCESS,timeout:2000,message:"Invitation de "+ that.state.nickname + " réussie"});}
             if(xhr.status==500) {toaster.show( {icon:"warning-sign", intent:Intent.DANGER,timeout:5000,message:"le nom ou pseudonyme : "+ that.state.nickname + " existe déja."}); }
            }
           
        }
}

  render() {
    const{usertoken,usernickname,userrole}=this.props
    return (
      <div>
        {this.props.pageid=="logout" ?<Card style={{width:270,margin:4}} interactive={true} elevation={Elevation.TWO}>
          <H3>Déconnexion</H3>
          <Button icon="log-out" onClick={(ev)=>{ev.preventDefault();this.props.handleLogout(false);if(usertoken.token!=undefined)this.setState({isOpendcnx:true})}}>Vous déconnecter</Button>
        </Card>:null}
        {/*this.props.userrole=="teacher"?this.props.pageid=="logout" ?<Card style={{width:270,margin:4}} interactive={true} elevation={Elevation.TWO}>
          <H3>Invitez une personne</H3>
          {this.state.codematiere=='' ? <div>Vous devez créer au moins une matière</div>:null}
          <Button disabled={this.state.codematiere==''} icon="following" onClick={(ev)=>{ev.preventDefault();if(usertoken.token!=undefined){ this.setState({isOpeninvit:true});}}}>Créer une invitation</Button>
        </Card>:null:null*/}
        {/*this.props.userrole=="teacher"?this.props.pageid=="logout" ?
          <Card style={{backgroundColor:'#e4eff7', width:'548px',margin:4}} interactive={true} elevation={Elevation.TWO}>
            <h3><Icon icon="applications" intent={Intent.PRIMARY} size={20}></Icon><a style={{marginLeft:10}} href="">Outils</a></h3>
            <a onClick={(ev)=>{if(this.state.isscreensity=='none')this.setState({isscreensity:'block'});else this.setState({isscreensity:'none'});}}><span style={{backgroundColor:'#2ba374',color:'#fff',borderRadius:'50%',padding: '2px 7px',marginRight:'7px'}}>1</span><b>Avec Screenity : Enregistrer votre écran, annoter ...</b></a>
            <div style={{display:this.state.isscreensity,padding: '10px 0 0 28px'}}>
              <img src="/data/Alyssax_screenity.gif"/>
            <p><b>Screenity est une extension pour Chrome gratuite et Open Source développée par Alyssa X</b></p>
            <p>Avec Screenity vous allez pouvoir</p>
            <ul>
              <li>Enregistrer votre écran</li>
              <li>Enregistrer votre voix</li>
              <li>Inscruster en direct votre Webcam</li>
              <li>Annoter en direct votre écran</li>
              <li>Sauvegarder la vidéo au format Mp4</li>
            </ul>
            <p>Pour installer Screenity dans Chrome</p>
            <ul>
            <li>1 - Télécharger le fichier Screenity depuis notre serveur:<a href="/data/1647520851.screenity.zip" target="_blank">lien du fichier Screenity</a></li>
            <li>2 - Décompresser le fichier reçu</li>
            <li>3 - Ouvrez Chrome et tapez <b>chrome://extensions/</b> dans le navigateur, et valider le mode developpeur en haut à droite de la fenêtre. </li>
            <li>4 - Cliquez sur le bouton "Charger l'extension non empaquetée" et choisir le dossier "screenity" où vous avez décompressé le fichier Screenity. </li>
            <li>5 - En haut à droite de chrome, cliquez sur le bouton en forme de puzzle pour accéder à screenity, vous pouvez l'accrocher à votre barre pour y accéder plus facilement.</li>
            </ul>
            <p>Bientôt ci-dessous, une vidéo pour vous montrer l'installation de Screenity</p>
            <video></video>
            </div>
    <p></p>          </Card>:null:null*/}

        <Overlay isOpen={this.state.isOpendcnx} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H3>Déconnexion</H3>
                        <div>
                        <img height="250" src={Logo} /> 
                        </div>
                        <p>
                            Vous pouvez vous déconnecter en toute tranquilité.
                        </p>
                      
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpendcnx:false})}} style={{ margin: "" }}>
                                Annuler
                            </Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{ev.preventDefault();this.handleLogout();this.setState({isOpendcnx:false});}} style={{ margin: "" }}>
                                Déconnexion
                            </Button>
                            
                            
                        </div>
                    </div>
        </Overlay>
        <Overlay isOpen={this.state.isOpeninvit} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H3>Créer une invitation</H3>
                        <div>
                        <img height="250" src={Logo} /> 
                        </div>
                        <p>
                           Générer une ivitation en cliquant sur le bouton ci-dessous après avoir entrer un nom ou pseudo pour reconnaitre plus tard votre invité.<br/>
                           Copier ensuite le lien pour permettre à un(e) invité(e) de se connecter à votre classe.<br />
                           Ce lien lui permettra, sans avoir à créer de compte et à s'identifier, de rejoindre votre classe. 
                        </p>
                        <br />
                        <input type="text" value={this.state.nickname} onChange={(ev)=>{this.handleChangeNom(ev)}} placeholder="Nom ou pseudonyme"/>
                        <br />
                        {this.state.uniqueid!=""?<QRCode includeMargin={true} value={this.state.uniqueid}/>:null}
                        {this.state.uniqueid!=""?<div><input style={{width:'100%'}} type="text" value={this.state.uniqueid} placeholder="lien à donner à votre futur(e) invité(e)"/><Button onClick={() => {navigator.clipboard.writeText(this.state.uniqueid)}} icon="array-date">Copier</Button></div>:null}
                        <br />
                        
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpeninvit:false})}} style={{ margin: "" }}>
                                Fermer
                            </Button>
                            <Button disabled={this.state.nickname==""} intent={Intent.DANGER} onClick={(ev)=>{ev.preventDefault();this.handleSendCnx()}} style={{ margin: "" }}>
                                Créer l'invitation
                            </Button>
                            
                            
                        </div>
                    </div>
        </Overlay>
        
      </div>
    );
  }
}
